import { NAME as APP_NAME, ROUTES as APP_ROUTES } from 'constants';
import { getObjectOptions } from 'domain/trip/model';
import { getPickupCities, getDropoffCities } from 'domain/fuse/apis';
import { getCouriers, searchAddressByValue } from 'domain/addressBook/api';
import { getFleetByName } from 'domain/fleets/apis';
import { getShippers } from 'domain/tap/apis';
import { getOptions } from 'domain/fuse/models/model';
import { getFleets } from 'domain/shipment/api';
import { getDriversByName } from 'domain/operations/drivers/apis';

import * as I18n from 'circe/I18n';

export const NAME = `${APP_NAME}/TRIPS`;

export const REDUCER_NAME = 'trips';

export const ROUTES = {
  ROOT: '/trips',
};
export const TRIPS_FILTERS = [
  { value: 'referenceId', label: I18n.str('referenceId', 'Reference Id') },
  { value: 'tripStatus', label: I18n.str('tripStatus', 'Trip Status') },
  { value: 'pickupCity', label: I18n.str('pickupCity', 'Pickup City') },
  { value: 'dropoffCity', label: I18n.str('dropoffCity', 'Dropoff City') },
  { value: 'tripId', label: I18n.str('tripId', 'Trip Id') },
  { value: 'tripCode', label: I18n.str('tripCode', 'Trip Code') },
  { value: 'vehicleType', label: I18n.str('vehicleType', 'Vehicle Type') },
  { value: 'courier', label: I18n.str('courier', 'Courier') },
  { value: 'accountType', label: I18n.str('accountType', 'Account Type') },
  { value: 'fleet', label: I18n.str('fleet', 'Fleet') },
  { value: 'direction', label: I18n.str('direction', 'Direction') },
  { value: 'loadType', label: I18n.str('loadType', 'Load Type') },
  {
    value: 'tempClassification',
    label: I18n.str('tempClassification', 'Temp Classification'),
  },
  { value: 'strategyType', label: I18n.str('strategyType', 'Strategy Type') },
  { value: 'productOwner', label: I18n.str('productOwner', 'Product Owner') },
  {
    value: 'pickupAddress',
    label: I18n.str('pickupAddress', 'Pickup Address'),
  },
  {
    value: 'dropoffAddress',
    label: I18n.str('dropoffAddress', 'Dropoff Address'),
  },
  {
    value: 'rejectionStates',
    label: I18n.str('rejectionStates', 'Rejection States'),
  },
];

export const TRIP_STATUS = {
  PROPOSED: 'PROPOSED',
  SCHEDULED: 'SCHEDULED',
  UN_SCHEDULED: 'UN_SCHEDULED',
  CONFIRMED: 'CONFIRMED',
  IN_PROGRESS: 'IN_PROGRESS',
  BLOCKED: 'BLOCKED',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  REJECTED: 'REJECTED',
  PENDING_CLOSE: 'PENDING_CLOSE',
};
export const TRIP_STATUS_OPTIONS = [
  { value: 'PROPOSED', label: I18n.str('PROPOSED', 'Proposed') },
  { value: 'SCHEDULED', label: I18n.str('SCHEDULED', 'Scheduled') },
  { value: 'UN_SCHEDULED', label: I18n.str('UN_SCHEDULED', 'Unscheduled') },
  { value: 'CONFIRMED', label: I18n.str('CONFIRMED', 'Confirmed') },
  { value: 'IN_PROGRESS', label: I18n.str('IN_PROGRESS', 'In Progress') },
  { value: 'BLOCKED', label: I18n.str('BLOCKED', 'Blocked') },
  { value: 'CANCELLED', label: I18n.str('CANCELLED', 'Cancelled') },
  { value: 'COMPLETED', label: I18n.str('COMPLETED', 'Completed') },
  { value: 'REJECTED', label: I18n.str('REJECTED', 'Rejected') },
  { value: 'PENDING_CLOSE', label: I18n.str('PENDING_CLOSE', 'Pending Close') },
];

export const ACCOUNTS = ['EMP', 'BROKER', 'IATCO'];
export const LOAD_TYPES = ['PALLET', 'NONE_PALLET'];
export const SHIPMENT_CLASSIFICATIONS = ['TC', 'DRY', 'FROZEN'];
export const STRATEGY_TYPES = ['LTL', 'FTL'];
export const ITINERARY_TYPES = ['NORMAL', 'RELOAD'];

export const STOP_TYPES = {
  PICKUP: 'PICKUP',
  RETURN: 'RETURN',
  DELIVERY: 'DELIVERY',
};
export const DIRECTIONS = [
  { value: 'FORWARD', label: I18n.str('forward', 'Forward') },
  { value: 'REVERSE', label: I18n.str('reverse', 'Reverse') },
];

export const BAD_VOLUME_UTILIZATION = 40;
export const BAD_WEIGHT_UTILIZATION = 40;

export const GOOD_VOLUME_UTILIZATION = 80;
export const GOOD_WEIGHT_UTILIZATION = 80;

export const REJECTION_STATES = [
  { value: 'REJECTED', label: I18n.str('rejected', 'REJECTED') },
  { value: 'RECEIVED', label: I18n.str('received', 'RECEIVED') },
  { value: 'CANCELLED', label: I18n.str('cancelled', 'CANCELLED') },
];

export const FACETS = {
  PICKUP_CITY: 'PICKUP_CITY',
  TRANSPORTER: 'TRANSPORTER',
  DROP_OFF_CITY: 'DROP_OFF_CITY',
};
export const FACETS_PARAMS = Object.values(FACETS);
export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/itineraries/query?refineBy=${FACETS_PARAMS}`;

export const SHOWN_FILTERS = () => [
  {
    name: I18n.str('couponNumber', 'Coupon Number'),
    type: 'Textfield',
    accessor: 'includeCoupons',
    placeholder: I18n.str('enterCouponNumber', 'Type coupon Id'),
  },
  {
    name: I18n.str('waybill', 'Waybill'),
    type: 'Textfield',
    accessor: 'includeWaybills',
    placeholder: I18n.str('enterWaybill', 'Type Waybill Id'),
  },
  {
    name: I18n.str('tripStatus', 'Trip Status'),
    type: 'Autocomplete',
    accessor: 'includeStatus',
    optionName: 'status',

    api: false,
    options: getObjectOptions(TRIP_STATUS),
  },
];

export const HIDDEN_FILTERS = (vehicleTypes) => [
  {
    name: I18n.str('startDate', 'Start Date'),
    type: 'Datefield',
    accessor: 'startDate',
  },
  {
    name: I18n.str('endDate', 'End Date'),
    type: 'Datefield',
    accessor: 'endDate',
  },
  {
    name: I18n.str('pickupCity', 'Pickup City'),
    type: 'Autocomplete',
    accessor: 'includePickupCity',
    optionName: 'pickupCity',

    api: true,
    getOptions: getPickupCities,
  },
  {
    name: I18n.str('dropoffCity', 'Dropoff City'),
    type: 'Autocomplete',
    accessor: 'includeDropoffCity',
    optionName: 'dropoffCity',

    api: true,
    getOptions: getDropoffCities,
  },
  {
    name: I18n.str('tripId', 'Trip Id'),
    type: 'Textfield',
    accessor: 'includeItineraryCode',
    placeholder: I18n.str('typeTripId', 'Type The Trip Id'),
  },
  {
    name: I18n.str('tripCode', 'Trip Code'),
    type: 'Textfield',
    accessor: 'includeSummaryCode',
    placeholder: I18n.str('typeTripCode', 'Type The Trip Code'),
  },
  {
    name: I18n.str('vehicleType', 'Vehicle Type'),
    type: 'Autocomplete',
    accessor: 'includeVehicleTypes',
    optionName: 'vehicleType',

    api: false,
    options: vehicleTypes?.map((item) => ({
      label: item.type.replaceAll('_', ' '),
      value: item.type,
    })),
  },
  {
    name: I18n.str('transporter', 'Transporter'),
    type: 'Autocomplete',
    accessor: 'accountIds',
    optionName: 'fleet',

    api: true,
    getOptions: getFleets,
  },
  {
    name: I18n.str('driver', 'Driver'),
    type: 'Autocomplete',
    accessor: 'driverIds',
    optionName: 'drivers',

    api: true,
    getOptions: getDriversByName,
  },
  {
    name: I18n.str('pickupAddress', 'Pickup Address'),
    type: 'Autocomplete',
    accessor: 'includePickupAddressCodes',
    optionName: 'pickupAddress',

    api: true,
    getOptions: searchAddressByValue,
  },
  {
    name: I18n.str('dropoffAddress', 'Dropoff Address'),
    type: 'Autocomplete',
    accessor: 'includeCustomerCodes',
    optionName: 'dropoffAddress',

    api: true,
    getOptions: searchAddressByValue,
  },
];

export const PAGE_NAME = 'trips';
